// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__25Cx0","row":"styles_row__2UOsr"};